import React from "react";

const NotificationsCard = () => {
  return (
    <div
      className="
        relative p-6 rounded-xl overflow-hidden
        bg-white text-gray-800 shadow-md ring-1 ring-black/5
        dark:bg-black/30 dark:text-gray-300 dark:backdrop-blur-lg
        dark:border dark:border-gray-700 dark:shadow-xl dark:ring-0
      "
    >
      <div className="flex justify-between items-center mb-5">
        <h4
          className="
            text-xl font-semibold font-fantasy
            text-gray-900 dark:text-indigo-400
          "
        >
          Notifications
        </h4>

        <span
          className="
            text-sm font-medium rounded-full w-8 h-8 flex items-center justify-center
            bg-gray-100 text-gray-700 shadow-sm
            dark:bg-gray-800 dark:text-gray-300 dark:shadow-none
          "
        >
          0
        </span>
      </div>

      <div className="text-center text-sm font-fantasy text-gray-500 dark:text-gray-400">
        No unread notifications
      </div>
    </div>
  );
};

export default NotificationsCard;
